<template>
  <div class="ksm-flex">
    <ModusIndex :viewKey="'texte'"></ModusIndex>
  </div>
</template>

<script>
import ModusIndex from "../../components/modus/ModusIndex";
export default {
  components: {
    ModusIndex
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss"
 scoped>
</style>


// WEBPACK FOOTER //
// TexteModus.vue?79234436